import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withQuery from './withQuery'

// HOC used by the registration payment step
const withPaymentQuery = compose(
  withRedux, // for setting error state
  withQueryResults, // for handling query errors
  withQuery // for fetching saved cart, payment profile, states/countries, etc
)

export { withPaymentQuery }
